import React from "react";
import { Button, Input, Checkbox, Select } from "antd";
import { FilePdfFilled } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import styles from "./style.module.scss";
import { Modal } from "components/General/ModalFormComponents";

const CustomDropDown = ({ onChange, selectedOption, options, placeholder }) => (
  <Select
    className={styles.dropdown}
    placeholder={placeholder}
    onChange={onChange}
    checked={selectedOption}
    showSearch
    optionFilterProp="title"
  >
    <Select.Option style={{ display: "none" }}>{placeholder}</Select.Option>
    {options?.map((option) => (
      <option key={option.ID} value={option.ID} title={option.Name}>
        {option.Name}
      </option>
    ))}
  </Select>
);

const Representation = ({
  showModal,
  setShowModal,
  handleClick,
  chooseInformationChecked,
  setChooseInformationChecked,
  aiChecked,
  setAIChecked,
  fixedChecked,
  setFixedChecked,
  customChecked,
  setCustomChecked,
  insightsChecked,
  setInsightsChecked,
  reviewsSwitch,
  setReviewsSwitch,
  setName,
  dashboards,
  selectedDashboard,
  setSelectedDashboard,
  subscriptionStatus,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <div className={styles.title}>
          <div className={styles.text}>
            <h5>{t("reports_page.title", "Custom Reports & Exports")}</h5>
            <h6>{t("reports_page.subtitle", "Find all your created reports and exported files here")}</h6>
          </div>
        </div>
        <div>
          <div className={styles.createBtn}>
            <Button
              icon={<i className="fa fa-plus" />}
              onClick={() => setShowModal(true)}
            >
              {t("reports_page.create_now", "Create your Report now")}
            </Button>
          </div>
        </div>
      </div>
      <Modal
        showModal={showModal}
        onClose={() => setShowModal(false)}
        onSave={handleClick}
        showSaveButton={true}
        textonButton={t("reports_page.ok", "OK")}
        titleAsset=""
        title={
          <div className={styles.modalTitle}>
            <FilePdfFilled style={{ fontSize: "32px" }} />
            {t("reports_page.create_new", "Create New Report")}
          </div>
        }
        widthofmodal="600px"
      >
        <div className={styles.modalContent}>
          <div className={styles.modalRow}>
            <p style={{ width: "146px", marginLeft: "-14px" }}>
              {t("reports_page.report_name", "Report Name")}
            </p>
            <Input
              placeholder={t("reports_page.report_name_placeholder", "Enter your report name")}
              onChange={(e) => setName(e.target.value)}
              className={styles.textAreaInput}
            />
          </div>
          <div className={styles.modalRow}>
            <p style={{ width: "150px", paddingleft: "0px", marginLeft: "-23px" }}>
              {t("reports_page.dashboard", "Dashboard")}
            </p>
            <CustomDropDown
              placeholder={t("reports_page.choose_dashboard", "Choose your dashboard")}
              options={dashboards}
              selected={selectedDashboard}
              onChange={(value) => setSelectedDashboard(value)}
            />
          </div>
          <div className={styles.checkboxContainer}>
            <div className={`${styles.checkboxRow} ${styles.marginBottom}`}>
              <Checkbox
                checked={chooseInformationChecked}
                onChange={(e) => setChooseInformationChecked(e.target.checked)}
              />
              <p>{t("reports_page.choose_info", "Choose the informations included in your report")}</p>
            </div>
            <div className={`${styles.checkboxRow} ${styles.marginLeft}`}>
              <Checkbox
                checked={insightsChecked}
                disabled={!chooseInformationChecked}
                onChange={(e) => setInsightsChecked(e.target.checked)}
              />
              <p className={!chooseInformationChecked && styles.disabledText}>
                {t("reports_page.insights", "Insights")}
              </p>
            </div>
            <div className={styles.verticalLine} />
            <div className={`${styles.checkboxRow} ${styles.marginLeft}`}>
              <Checkbox
                checked={aiChecked}
                disabled={!chooseInformationChecked}
                onChange={(e) => setAIChecked(e.target.checked)}
              />
              <p className={!chooseInformationChecked && styles.disabledText}>
                {t("reports_page.ai_topics", "AI topics")}
              </p>
            </div>
            <div className={styles.verticalLine} />
            <div className={`${styles.checkboxRow} ${styles.marginLeft}`}>
              <Checkbox
                checked={fixedChecked}
                disabled={!chooseInformationChecked}
                onChange={(e) => setFixedChecked(e.target.checked)}
              />
              <p className={!chooseInformationChecked && styles.disabledText}>
                {t("reports_page.fixed_topics", "Fixed topics")}
              </p>
            </div>
            <div className={styles.verticalLine} />
            <div className={`${styles.checkboxRow} ${styles.marginLeft}`}>
              <Checkbox
                checked={customChecked}
                disabled={!chooseInformationChecked}
                onChange={(e) => setCustomChecked(e.target.checked)}
              />
              <p className={!chooseInformationChecked && styles.disabledText}>
                {t("reports_page.custom_topics", "Custom topics")}
              </p>
            </div>
          </div>
          <div className={styles.switchContainer}>
            <p className={styles.switchText}>
              {t("reports_page.include_all_reviews", "Include all reviews")}
            </p>
            <div className={styles.dynamicBtn}>
              <input
                type="checkbox"
                id="reviews-switch"
                checked={reviewsSwitch}
                disabled={
                  subscriptionStatus?.PackageId < 76 ||
                  subscriptionStatus?.PackageId === 80
                }
                onClick={(e) => setReviewsSwitch(e.target.checked)}
              />
              <label htmlFor="reviews-switch">Toggle</label>
            </div>
            <div className={styles.proTag}>{t("reports_page.for_pro", "For PRO")}</div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Representation;
